import { Mandates } from "../../../shared/components/mandates/mandates";
import { UserTypes } from "../../../shared/constants";

export function FrontOfficeMandates() {
  return <Mandates userType={UserTypes.Frontoffice} />;
}
